import React from 'react';
import RevistasEroski from '../pages/Revistas/indexEroski';
import RevistasCaprabo from '../pages/Revistas/indexCaprabo';
import NotFound from '../pages/NotFound';
import SinTarjetaOroEroski from '../pages/TarjetasOro/SinTarjetaOro/indexEroski';
// eslint-disable-next-line import/no-cycle
import TarjetaOroDatosEroski from '../pages/TarjetasOro/TarjetaOroDatos/indexEroski';
import CotitularEroski from '../pages/Tarjetas/Cotitular/indexEroski';
import CotitularTpecEroski from '../pages/Tarjetas/CotitularTpec/indexEroski';
import NoTitularEroski from '../pages/Tarjetas/NoTitular/indexEroski';
import TitularEroski from '../pages/Tarjetas/Titular/indexEroski';
import TitularOroEroski from '../pages/Tarjetas/TitularOro/indexEroski';
import TitularOroTpecEroski from '../pages/Tarjetas/TitularOroTpec/indexEroski';
import TitularTpecEroski from '../pages/Tarjetas/TitularTpec/indexEroski';
import SinTarjetaOroCaprabo from '../pages/TarjetasOro/SinTarjetaOro/indexCaprabo';
import TarjetaOroDatosCaprabo from '../pages/TarjetasOro/TarjetaOroDatos/indexCaprabo';
import CotitularCaprabo from '../pages/Tarjetas/Cotitular/indexCaprabo';
import CotitularTpecCaprabo from '../pages/Tarjetas/CotitularTpec/indexCaprabo';
import NoTitularCaprabo from '../pages/Tarjetas/NoTitular/indexCaprabo';
import TitularOroCaprabo from '../pages/Tarjetas/TitularOro/indexCaprabo';
import TitularOroTpecCaprabo from '../pages/Tarjetas/TitularOroTpec/indexCaprabo';
import TitularTpecCaprabo from '../pages/Tarjetas/TitularTpec/indexCaprabo';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { CookieHelper } from './CookieHelper';
import PuntosTravelEroski from '../pages/PuntosTravel/indexEroski';
import { HostProvider } from './HostProvider';

const isCaprabo = HostProvider.isCaprabo();
const isEroski = HostProvider.isEroski();

// eslint-disable-next-line import/prefer-default-export
export class SystemManager {
  static getSystem = (section: string) => {
    //  Pantallas Eroski
    if (isEroski) {
      if (section === 'puntos-travel') {
        return (
          <>
            <PuntosTravelEroski />
          </>
        );
      }
      if (section === 'revistas') {
        return (
          <>
            <RevistasEroski />
          </>
        );
      }
      if (section === 'tarjeta-oro') {
        return (
          <>
            <SinTarjetaOroEroski />
          </>
        );
      }
      if (section === 'tarjeta-oro-datos') {
        return (
          <>
            <TarjetaOroDatosEroski />
          </>
        );
      }
      if (section === 'tarjeta-cotitular') {
        return (
          <>
            <CotitularEroski />
          </>
        );
      }
      if (section === 'tarjeta-cotitular-tpec') {
        return (
          <>
            <CotitularTpecEroski />
          </>
        );
      }
      if (section === 'sin-tarjeta') {
        return (
          <>
            <NoTitularEroski />
          </>
        );
      }
      if (section === 'tarjeta-titular') {
        return (
          <>
            <TitularEroski />
          </>
        );
      }
      if (section === 'tarjeta-titular-oro') {
        return (
          <>
            <TitularOroEroski />
          </>
        );
      }
      if (section === 'tarjeta-titular-oro-tpec') {
        return (
          <>
            <TitularOroTpecEroski />
          </>
        );
      }
      if (section === 'tarjeta-titular-tpec') {
        return (
          <>
            <TitularTpecEroski />
          </>
        );
      }
      //  Pantallas Caprabo
    } else if (isCaprabo) {
      if (section === 'puntos-travel') {
        return (
          <>
            <NotFound />
          </>
        );
      }
      if (section === 'revistas') {
        return (
          <>
            <RevistasCaprabo />
          </>
        );
      }
      if (section === 'tarjeta-oro') {
        return (
          <>
            <SinTarjetaOroCaprabo />
          </>
        );
      }
      if (section === 'tarjeta-oro-datos') {
        return (
          <>
            <TarjetaOroDatosCaprabo />
          </>
        );
      }
      if (section === 'tarjeta-cotitular') {
        return (
          <>
            <CotitularCaprabo />
          </>
        );
      }
      if (section === 'tarjeta-cotitular-tpec') {
        return (
          <>
            <CotitularTpecCaprabo />
          </>
        );
      }
      if (section === 'sin-tarjeta') {
        return (
          <>
            <NoTitularCaprabo />
          </>
        );
      }
      if (section === 'tarjeta-titular-oro') {
        return (
          <>
            <TitularOroCaprabo />
          </>
        );
      }
      if (section === 'tarjeta-titular-oro-tpec') {
        return (
          <>
            <TitularOroTpecCaprabo />
          </>
        );
      }
      if (section === 'tarjeta-titular-tpec') {
        return (
          <>
            <TitularTpecCaprabo />
          </>
        );
      }
    }
    return <NotFound />;
  };
}
